import React from "react";
import PropTypes from "prop-types";

const CustomSlider = ({ value, color }) => {
  const trackStyle = {
    position: "relative",
    height: "10px",
    backgroundColor: "#e0e0e0",
    borderRadius: "5px",
    width: "100%",
    overflow: "hidden", // Ensures filled content respects track edges
  };

  const filledStyle = {
    height: "10px",
    backgroundColor: color,
    width: `${value}%`,
    borderRadius:
      value === 100 ? "0 5px 5px 0" : value === 0 ? "5px 0 0 5px" : "0", // Flat edges for filled portion
  };

  return (
    <div style={{ width: "80px", padding: "10px 0" }}>
      <div style={trackStyle}>
        <div style={filledStyle}></div>
      </div>
    </div>
  );
};

CustomSlider.propTypes = {
  value: PropTypes.number.isRequired, // Value between 0 and 100
  color: PropTypes.string.isRequired, // Color for the filled track
};

export default CustomSlider;
